import React from 'react';
import {useSearchParams} from 'react-router-dom';
import {PaymentConfirmation} from 'components/customer/Confirmation/Gateways/Stripe/PaymentConfirmation';
import {GatewayCode} from 'components/manufacturer/Payments/entity/Gateway';

export const Confirmation = () => {
    const [searchParams] = useSearchParams();

    if (
        searchParams.has('gateway') &&
        searchParams.get('gateway')?.toLowerCase() == GatewayCode.STRIPE
    ) {
        return <PaymentConfirmation />;
    }

    return null;
};
